<template>
  <div class="mobile-wrapper">
    <div
      class="justify-content-center so-finalize text-center"
      :style="BackgroundColor"
    >
      <div class="big-logo">
        <img :src="Logo" @error="imgHttpError" />
      </div>
      <div class="step-title">
        {{ $t("message.finalizeSoCompleteTitle") }}
      </div>
      <div class="step-desc">{{ $t("message.finalizeSoCompleteMessage") }}</div>
      <div class="text-center" style="margin-top: 62px">
        <AppleWallet :user-id="userId" v-if="isIos" :store-id="storeid"
          style="margin: 10px auto; width: 307px" />
        <GooglWallet
          v-if="!isIos"
          @update-status="(u) => updateStatus(u)"
          style="margin: 10px auto; width: 307px"
          :user-id="userId"
          :store-id="storeid"
          :store-name="storename"
        />
        <button
          type="button"
          :style="mobileStyles.btn"
          style="
            border-radius: 3px;
            margin: 0 auto;
            font-size: 14px;
            width: 307px;
            color: #ffffff !important;
          "
          class="btn btn-primery"
          @click="saveAsImage()"
        >
          {{ $t("message.DownloadAsImage") }}
        </button>
      </div>

      <div class="logo-powered-by">Powered by</div>
      <div class="abacus-logo"></div>
    </div>
    <progressindicator
      v-if="showProgress"
      style="opacity: 0.4"
    ></progressindicator>
  </div>
</template>

<script>
import GooglWallet from "./partials/googleWallet.vue";
import AppleWallet from "./partials/appleWallet.vue";
import progressindicator from "../progressindicator";
import { mapGetters } from "vuex";
import { wcconfig } from "../../../wcConfig";
import QRCode from "qrcode";
export default {
  components: {
    GooglWallet,
    progressindicator,
    AppleWallet,
  },
  props: {
    userId: {
      type: String,
      default: null,
    },
    storeid: {
      type: String,
      default: null,
    },
    storename: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      qrCodeHref: null,
      logoUrl: "",
      showProgress: false,
    };
  },
  created() {
    this.logoUrl = wcconfig.assets.abacus;
  },
  computed: {
    ...mapGetters(["mobileStyles", "viewConfig", "currentStoreDoc"]),
    isIos() {
      var isIos = !!navigator.platform.match(/iPhone|iPod|iPad/) || !!navigator.platform.match(/Mac68K|MacPPC|MacIntel/);
      return isIos;
    },
    Logo() {
      if (
        this.currentStoreDoc &&
        this.currentStoreDoc.ThemeSettings &&
        this.currentStoreDoc.ThemeSettings.BackgroundPhotos
      ) {
        return this.currentStoreDoc.ThemeSettings.BackgroundPhotos.CommonLogo;
      }
      return "";
    },
    BackgroundColor() {
      var styles = [];
      var colour = "#3994ff";
      if (
        this.currentStoreDoc &&
        this.currentStoreDoc.ThemeSettings &&
        this.currentStoreDoc.ThemeSettings.Colours &&
        this.currentStoreDoc.ThemeSettings.Colours.IntroBackground
      ) {
        colour = this.currentStoreDoc.ThemeSettings.Colours.IntroBackground;
      }
      styles.push({ "background-color": `${colour}` });
      return styles;
    },
  },
  async mounted() {
    var a = document.getElementById("qrCodeContainer");
    await QRCode.toCanvas(a, ";" + this.userId);
  },
  methods: {
    async saveAsImage() {
      var dataUrl = await QRCode.toDataURL(";" + this.userId);
      var a = document.createElement("a");
      a.download = "QrCode.png";
      a.href = dataUrl;
      a.click();
    },
    imgHttpError(event) {
      if (event && event.target && event.target.style)
        event.target.style.display = "none";
    },
    updateStatus(status) {
      if (!status) {
        setTimeout(() => {
          this.showProgress = status;
        }, 1000);
      } else this.showProgress = status;
    },
  },
};
</script>

<style lang="scss">
.vdpComponent {
  display: block;
}
.required-logo {
  color: red;
}
.centered {
  position: fixed;
  top: 13%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.success {
  background-color: #22bb33;
  border-radius: 10px;
  padding: 15px 15px;
}
.error {
  background-color: #bb2124;
  border-radius: 15px;
  padding: 5px 10px;
}
.messagetext {
  margin-bottom: 5px !important;
  color: white;
}
.messagebtn {
  text-align: right;
  margin-bottom: 5px !important;
  color: white;
  cursor: pointer;
}

.oo-module {
  .mobile-wrapper {
    .so-finalize {
      min-height: 100vh;
      background: #3994ff 0% 0% no-repeat padding-box;
      opacity: 0.95;
      .step-title {
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
        margin-top: 115px;
        margin-left: auto;
        margin-right: auto;
        width: 242px;
      }

      .step-desc {
        width: 95%;
        font-size: 16px;
        color: #ffffff;
        margin-top: 30px;
        margin-left: auto;
        margin-right: auto;
      }

      .big-logo {
        margin-top: 0;
        padding-top: 25%;
        margin-left: 0;
        max-height: 158px;
        max-width: 93px;
        margin-left: auto;
        margin-right: auto;
        img {
          max-height: 100%;
          max-width: 100%;
        }
      }

      .abacus-logo {
        margin-left: auto;
        margin-right: auto;
        height: 26px;
        width: 100px;
        background: transparent url("./../../assets/abacus-logo-white.png") 0%
          0% no-repeat padding-box;
        opacity: 1;
        background-size: contain;
        padding-bottom: 50px;
      }
      .logo-powered-by {
        margin-left: auto;
        margin-right: auto;
        width: 82px;
        font-size: 10px;
        color: #ffffff;
        margin-top: 50px;
      }
    }
  }
}
</style>

